//menu
import "./modules/menu.js";
import "./modules/fancyBox.js";
// import "./modules/doScroll.js";
// import "./modules/scrollAnimation";
import "./modules/menuAnimation";
import "./modules/form.js";
import "./modules/dynamic-section.js";
import "./modules/splide.js";
import "./modules/accordion.js";
import "./modules/tabs.js";
import "./modules/rolled.js";
import "./modules/clipboard.js";
import "./modules/expand-tags.js";

// import "./modules/parallax";

document.addEventListener("DOMContentLoaded", function () {
  function togglePageInteractivity() {
    const box = document.querySelector(".cm--box");
    if (!box) return;

    const isHidden = box.getAttribute("aria-hidden") === "true";

    if (!isHidden) {
      document.body.style.overflow = "hidden";
      document.body.style.pointerEvents = "none";
    } else {
      document.body.style.overflow = "";
      document.body.style.pointerEvents = "";
    }
  }

  const target = document.querySelector(".cm--box");
  if (target) {
    const observer = new MutationObserver(togglePageInteractivity);

    observer.observe(target, {
      attributes: true,
      attributeFilter: ["aria-hidden"],
    });

    togglePageInteractivity();
  }
});
